import React from 'react';
import ReactDOM from 'react-dom/client';

import '@link/emot/i18n';
import '@link/emot/styles/index.css';
import App from '@link/emot/App';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
